export const GLOBAL_ROUTES = {
	HOME: "/",
	LOGIN: "/login",
	TEAM: "/team",
	PROBLEMS: "/problems",
	PROBLEM_DETAILS: "/problems",
	API_GUIDE: "/api-guide",
	INDIVIDUAL_LEADERBOARD: "/individual-leaderboard",
	TEAM_LEADERBOARD: "/team-leaderboard",
	TERMS_OF_USE_AND_PRIVACY_POLICY: "/privacy-policy",
	OAUTH_CALLBACK: "/oauth-callback",
	REPORT_PROBLEM: "/report-a-problem",
};
